export const GET_ALL_PLANS_REQUEST='allPlanReducer/GET_ALL_PLANS_REQUEST'
export const GET_ALL_PLANS_SUCCESS='allPlanReducer/GET_ALL_PLANS_SUCCESS'
export const GET_ALL_PLANS_FAILED='allPlanReducer/GET_ALL_PLANS_FAILED'